import { render, staticRenderFns } from "./ImportContacts.vue?vue&type=template&id=6ec40e0d"
import script from "./ImportContacts.vue?vue&type=script&lang=js"
export * from "./ImportContacts.vue?vue&type=script&lang=js"
import style0 from "./ImportContacts.vue?vue&type=style&index=0&id=6ec40e0d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports